import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

const toast = {
    error: (message, title = 'Error') => {
        return iZtoast.error({
            progressBar: false,
            title: title,
            message: message,
            displayMode: 2,
            position: 'bottomCenter'
        });
    },
    permanentWarning: (message, title) => {
        return iZtoast.warning({
            class: 'csm-perma-toast',
            timeout: false,
            progressBar: false,
            title: title,
            message: message,
            displayMode: 2,
            close: false,
            position: 'bottomLeft'
        });
    },
    success: (message, title = 'Success') => {
        return iZtoast.success({
            progressBar: false,
            title: title,
            message: message,
            position: 'bottomCenter'
        });
    },
    info: (message, title = 'Info', customClass = 'csm-loader') => {
        return iZtoast.info({
            progressBar: false,
            title: title,
            message: message,
            class: customClass,
            timeout: 3000,
            displayMode: 2,
            position: "bottomCenter"
        })
    },
    hide: (customClass = 'csm-loader') => {
        let toast = document.querySelector('.iziToast');
        if(toast) {
            iZtoast.hide({}, toast);
        }
    }
};

export default toast;